import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { Sidebar } from "../../../containers/Sidebar/Sidebar";
import useStyles from "./styles";
import { CustomTable } from "../../../components/CustomTable/CustomTable";
import { useTranslation } from "react-i18next";

import { CustomButtonTable } from "../../../components/CustomButtonTable/CustomButtonTable";
import { useCallback, useMemo, useState } from "react";
import { useGetAllNotification } from "../../../api/notification";
import { getCurrentFleetId } from "../../../utils/getCurrentFleet";
import { CustomLoader } from "../../../components/CustomLoader/CustomLoader";
import { getColumnsNotification } from "./notificationColumns";
import { NotificationBulkActions } from "./NotificationBulkActions";

type Props = {};

export const ListNotification: React.FC<Props> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const fleetId = getCurrentFleetId();
  const { notifications, isPending } = useGetAllNotification(fleetId);

  // Keye sur `t` : les en-tetes se reconstruisent au changement de langue.
  const columns = useMemo(() => getColumnsNotification(t), [t]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  /*
   * The table owns the checkboxes but the page owns what to DO with them, so
   * the selection has to be lifted. Without this handler the page never knew
   * anything was ticked — which is half of why the bulk menu could not work.
   */
  const [selected, setSelected] = useState<TNotification[]>([]);

  const handleSelectRow = useCallback((rows: Record<string, any>[]) => {
    setSelected(rows as TNotification[]);
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {isPending && <CustomLoader isActive={isPending} />}
      <Sidebar
        styles={{
          sidebarRightRoot: classes.vehiculeRoot,
          sidebarRoot: classes.contentMain,
        }}
      >
        <div className={classes.containerHeader}>
          <CustomTypography
            variant="h2"
            text={t("sidebar.notifications", "Notifications")}
            isUppercase
          />
        </div>
        <CustomTable
          columns={columns}
          data={notifications}
          isSearchable
          showSelectedField
          isBackgroundUnique
          onSelectRow={handleSelectRow}
          componentHeader={
            <>
              <CustomButtonTable
                variant={"primary"}
                textVariant={"link"}
                label={
                  selected.length > 0
                    ? t("common.groupeActionsCount", {
                        defaultValue: "Actions groupées ({{count}})",
                        count: selected.length,
                      })
                    : t("common.groupeActions", "Groupe actions")
                }
                width={"fit-content"}
                fontWeight={"bold"}
                textDecoration={"none"}
                iconName={"chevronDown"}
                padding={"0px 15px"}
                textTransform="uppercase"
                endIcon
                onClick={handleClick}
              />
              <NotificationBulkActions
                anchorEl={anchorEl}
                open={open}
                handleClose={handleClose}
                selected={selected}
                fleetId={fleetId}
                onDone={() => setSelected([])}
              />
            </>
          }
        />
      </Sidebar>
    </>
  );
};
